import * as React from 'react';

import { Widget } from '~/components/MyWorkspace/Widget';
import { WidgetProps } from '~/scenes/MyWorkspace/components/Widgets/data';

export interface Props extends WidgetProps {}

export const PlaceholderWidget: React.FC<Props> = ({ title }) => {
  return (
    <Widget title={title || ''} dataCy="quick-links-widget" content={<></>} />
  );
};
